import React from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import FASTable from "../../../../../components/Tables/FASTable";
import {
  PayOutstanding,
  PayOutstandingFun,
} from "../../../../../Redux/Slice/Fas/ReceivablePayble/ReceivablePaybleSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { format } from "date-fns";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function PaymentOutstanding({
  accountGroup,
  accountName,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const { PayOutstandingdata } = useSelector(
    (state) => state.ReceivablePaybleSlice,
  );

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  const getRows = PayOutstandingdata?.Detail?.map((label, index) => ({
    // srNumber: index + 1,
    AcName: label.AcName,
    Outstanding: label.Outstanding,
    Collection: label.Collection,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Account Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Outstanding",
      key: "Outstanding",
      align: "right",
      format: "true",
    },
    { label: "Collection", key: "Collection", align: "right", format: "true" },
  ];

  if (PayOutstandingdata === "no" || PayOutstandingdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            PAYMENT OUTSTANDING
          </h2>
        </div>

        <FASTable columns={getColumns} data={getRows} />
      </div>
    </div>
  );
}
